module.exports = __webpack_public_path__ + "static/media/step.48f356fd.svg";